/**
 * Edit Types
 *
 * Part I, Section 26
 */
export enum EditType {
  MainAsset = "Main Asset",
  ShorterOrLongerVersion = "Shorter Or Longer Version",
  PermittedChanges = "Permitted Changes",
  PaidEdits = "Paid Edits",
  AddressableEdits = "Addressable Edits",
}
